<div class="main-content-wrapper" data-testid="main-content-wrapper">
  <!-- Categories and fav Categories navBar-->
  <div class="dept-navbar" data-testid="category-navbar">
    <button
      class="nav-link d-flex align-items-center"
      [class.active]="isButtonActive"
      (click)="toggleButtons()"
      data-testid="favorites-btn"
    >
      {{ "Favorites" | translate }}
      <span id="favQty" class="ms-2" data-testid="favorites-qty">{{ favQuantity }}</span>
    </button>
    <button
      class="nav-link"
      [class.active]="!isButtonActive"
      (click)="toggleButtons()"
      data-testid="all-category-btn"
    >
      {{ "All Category" | translate }}
    </button>
  </div>
  <!-- Categories and fav Categories Content-->
  <div class="dept-wrapper mt-3" data-testid="category-wrapper">
    <div class="row" *ngIf="!isButtonActive" data-testid="category-row">
      <div
        class="col-xl-3 col-md-4 col-sm-6 position-relative"
        *ngFor="let item of renderWomensDepartmentDat; let i = index"
        data-testid="category-card"
      >
        <div class="dept-content" (click)="selectedCategory(item)" data-testid="category-content">
          <div class="icon" data-testid="category-icon">
            <img class="img-fluid" [src]="item.imageIcon || 'assets/Pos-Catalog/akar-icons_image.svg'" (error)="item.imageIcon = 'assets/Pos-Catalog/akar-icons_image.svg'" data-testid="category-img" />
          </div>
          <h6 (click)="selectedCategory(item)" data-testid="category-title">
            {{ item.categoryName }}
          </h6>
        </div>
        <div class="favrIcon" style="text-align: end" data-testid="category-fav-icon">
          <i
            class="fa-regular fa-star fa-xl"
            *ngIf="!item.favoriteId"
            (click)="fav(item)"
            data-testid="category-fav-unselected"
          ></i>
          <i
            class="fa-solid fa-star fa-xl"
            style="color: #eda519"
            *ngIf="item.favoriteId"
            (click)="fav(item)"
            data-testid="category-fav-selected"
          ></i>
        </div>
      </div>
    </div>

    <!--Row for displaying fav items-->
    <div class="row" *ngIf="isButtonActive" data-testid="favorites-row">
      <div
        class="col-xl-3 col-md-4 col-sm-6 position-relative"
        *ngFor="let favItem of combinedItemsList"
        data-testid="favorite-card"
      >
        <div class="dept-content" (click)="selectedCategory(favItem)" data-testid="favorite-content">
          <div class="icon" (click)="selectedCategory(favItem)" data-testid="favorite-icon">
            <img class="img-fluid" [src]="favItem.imageIcon || 'assets/Pos-Catalog/akar-icons_image.svg'" (error)="favItem.imageIcon = 'assets/Pos-Catalog/akar-icons_image.svg'" data-testid="favorite-img" />
          </div>
          <h6 (click)="selectedCategory(favItem)" data-testid="favorite-title">
            {{
              favItem.subCategoryId
                ? favItem.departmentDescr +
                  " / " +
                  favItem.categoryName +
                  " / " +
                  favItem.subCategoryName
                : favItem.categoryName != null
                ? favItem.departmentDescr + " / " + favItem.categoryName
                : favItem.departmentDescr
            }}
          </h6>
        </div>
        <div class="favrIcon" style="text-align: end" data-testid="favorite-fav-icon">
          <i
            class="fa-solid fa-star fa-xl"
            style="color: #eda519"
            (click)="fav(favItem)"
            data-testid="favorite-fav-selected"
          ></i>
        </div>
      </div>
    </div>
  </div>
</div>
